export default __webpack_public_path__ + "static/media/hot-inarticle.bc91802a.jpg";